function Footer() {
  return (
    <footer className="container mx-auto py-5 text-xs">
      &copy; 2024 VISCONTI Partners
    </footer>
  );
}

export default Footer;
